module.exports = __webpack_public_path__ + "static/media/Frostyz logo-07.1fad6ea0.jpg";